import BaseLayout from '@/layout/BaseLayout'
import activitesMap from './activitesMap'
import { cakeBaseRoute, cakeTabMap } from './cakeMap'
import routeMap from './routeMap'
import tabbar from './tabbarRoute'

// const RouteView = {
//   name: 'RouteView',
//   render: h => h('router-view')
// }

const routes = [
  {
    path: '/',
    redirect: '/tabbar/home',
    component: BaseLayout,
    children: [
      ...tabbar,
      ...routeMap,
      ...activitesMap,
      ...cakeTabMap,
      ...cakeBaseRoute
    ]
  }
]

export default routes